import Api from "../apiService";

class PermissionRolesApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/permission_roles`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/permission_roles/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/permission_roles`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/permission_roles/${id}`,
      data,
      Api.authHeaders()
    );
  }

  delete(companyId, id) {
    return Api.deleteRequest(
      `companies/${companyId}/permission_roles/${id}`,
      Api.authHeaders()
    );
  }

  grid(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/permission_roles/${id}/grid`,
      {},
      Api.authHeaders()
    );
  }

  toggle(companyId, id, targetResource, permissionAction) {
    return Api.postRequest(
      `companies/${companyId}/permission_roles/${id}/toggle`,
      {
        target_resource: targetResource,
        permission_action: permissionAction,
      },
      Api.authHeaders()
    );
  }

  resourceScope(companyId, id, targetResource, dataScope) {
    return Api.patchRequest(
      `companies/${companyId}/permission_roles/${id}/resource_scope`,
      { target_resource: targetResource, data_scope: dataScope },
      Api.authHeaders()
    );
  }

  resetToDefault(companyId, id) {
    return Api.postRequest(
      `companies/${companyId}/permission_roles/${id}/reset_to_default`,
      {},
      Api.authHeaders()
    );
  }

  pagesAccess(companyId) {
    return Api.getRequest(
      `companies/${companyId}/permission_roles/pages_access`,
      {},
      Api.authHeaders()
    );
  }
}

export default new PermissionRolesApi();
